const initState={};

const PaymentDropdownReducer = (state = initState, action) => {
    switch(action.type) {
        case  'PaymentDropdown' : return  action.payload;
        default: return state;
    }
}
export default PaymentDropdownReducer;